interface KpiData {
  /** 업체 아이디 */
  companyId: number;
  dashBoardGraph:
    | "PRODUCTION"
    | "LEAD_TIME"
    | "OPERATION_RATE"
    | "DELIVERY_RATE"
    | "VISITOR_COUNT"
    | "CUSTOMER_COUNT"
    | "ORDER_COUNT"
    | "PAYMENT_AMOUNT";
  /**
   * 표시할 척도 (생산량, 리드타임 단축율, 가동률 향상, 납기 준수율 향상)
   * 필요에 따라 각 업체에 해당하는 척도만 포함시켜주세요. */
  availableMetrics: (
    | "PRODUCTION"
    | "LEAD_TIME"
    | "OPERATION_RATE"
    | "DELIVERY_RATE"
    | "VISITOR_COUNT"
    | "CUSTOMER_COUNT"
    | "ORDER_COUNT"
    | "PAYMENT_AMOUNT"
  )[];
  metrics: {
    /** 생산량 증가 (퍼센트) */
    productionIncreaseRate: number;
    /** 생산량 이전 평균 */
    productionAvgPrevious: number;
    /** 생산량 현재 평균 */
    productionAvgCurrent: number;
    /** 생산량 평균 증가량 */
    productionAvgChange: number;
    /** 생산량 달성률 */
    productionAchievementRate: number;
    /** 생산량 단위 */
    productionUnit: string;

    /** 리드타임 단축율 (퍼센트) */
    leadTimeReductionRate: number;
    /** 리드타임 단축율 이전 평균 */
    leadTimeAvgPrevious: number;
    /** 리드타임 단축율 현재 평균 */
    leadTimeAvgCurrent: number;
    /** 리드타임 단축시간 */
    leadTimeAvgChange: number;
    /** 리드타임 단축 달성률 */
    leadTimeAchievementRate: number;
    /** 리드타임 단위 */
    leadTimeUnit: string;

    /** 가동률 향상 (퍼센트) */
    operationRateIncreaseRate: number;
    /** 가동률 이전 평균 */
    operationRateAvgPrevious: number;
    /** 가동률 현재 평균 */
    operationRateAvgCurrent: number;
    /** 가동률 향상 */
    operationRateAvgChange: number;
    /** 가동룰 향상 달성율 */
    operationRateAchievementRate: number;
    /** 가동률 단위 */
    operationRateUnit: string;

    /** 납기 준수율 향상 (퍼센트) */
    deliveryRateIncreaseRate: number;
    /** 납기 준수율 이전 평균 */
    deliveryRateAvgPrevious: number;
    /** 납기 준수율 이전 평균 */
    deliveryRateAvgCurrent: number;
    /** 납기 준수율 향상 */
    deliveryRateAvgChange: number;
    /** 납기 준수율 달성률 */
    deliveryRateAchievementRate: number;
    /** 납기 준수율 단위 */
    deliveryRateUnit: string;
  };
  /** KPI 추이 분석 그래프 데이터 */
  graphData: {
    /** 날짜. "MM/DD 형식으로 작성 */
    date: string;
    /** 일별 생산량 */
    dailyProduction: number;
    /** 일별 리드타임 */
    dailyLeadTime: number;
    /** 가동률 */
    operationRate: number;
    /** 납기 준수율 */
    deliveryComplianceRate: number;
  }[];
  /** 주간 요약 */
  weeklySummary: {
    /** 리드타임 평균 */
    leadTimeAvg: number;
    /** 생산량 평균 */
    productionAvg: number;
    /** 가동률 평균 */
    operationRateAvg: number;
    /** 납기 준수율 평균 */
    deliveryRateAvg: number;
  };
}

export const fallbackKpiData = {
  companyId: 6,
  availableMetrics: ["PRODUCTION", "LEAD_TIME"],
  metrics: {
    productionIncreaseRate: 24.7,
    productionAvgPrevious: 500,
    productionAvgCurrent: 622.5,
    productionAvgChange: 122.5,
    productionAchievementRate: 103.8,
    productionUnit: "장/시간",

    leadTimeReductionRate: 35.0,
    leadTimeAvgPrevious: 3.5,
    leadTimeAvgCurrent: 2.2,
    leadTimeAvgChange: 1.4,
    leadTimeAchievementRate: 101,
    leadTimeUnit: "일",

    operationRateIncreaseRate: 0,
    operationRateAvgPrevious: 0,
    operationRateAvgCurrent: 0,
    operationRateAvgChange: 0,
    operationRateAchievementRate: 0,
    operationRateUnit: "_",

    deliveryRateAvgChange: 0,
    deliveryRateAvgPrevious: 0,
    deliveryRateAvgCurrent: 0,
    deliveryRateIncreaseRate: 0,
    deliveryRateAchievementRate: 0,
    deliveryRateUnit: "_",
  },
  graphData: [
    {
      date: "11/3",
      dailyProduction: 617.5,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/4",
      dailyProduction: 613.3,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/5",
      dailyProduction: 616,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/6",
      dailyProduction: 618.5,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/7",
      dailyProduction: 614,
      dailyLeadTime: 2.2,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/10",
      dailyProduction: 619.875,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/11",
      dailyProduction: 613.33,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/12",
      dailyProduction: 615.125,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/13",
      dailyProduction: 612.25,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/14",
      dailyProduction: 613.5625,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/17",
      dailyProduction: 615.5,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/18",
      dailyProduction: 609.25,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/19",
      dailyProduction: 609.25,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/20",
      dailyProduction: 617.8125,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
    {
      date: "11/21",
      dailyProduction: 609.6375,
      dailyLeadTime: 2.3,
      operationRate: 0,
      deliveryComplianceRate: 0,
    },
  ],
  weeklySummary: {
    productionAvg: 612.466,
    leadTimeAvg: 2.3,
    operationRateAvg: 0,
    deliveryRateAvg: 0,
  },
};

export const kpiData: KpiData[] = [
  {
    // 마니프로젝트
    companyId: 2,
    dashBoardGraph: "OPERATION_RATE",
    availableMetrics: ["OPERATION_RATE", "DELIVERY_RATE"],
    metrics: {
      productionIncreaseRate: 0,
      productionAvgPrevious: 0,
      productionAvgCurrent: 0,
      productionAvgChange: 0,
      productionAchievementRate: 0,
      productionUnit: "_",

      leadTimeReductionRate: 0,
      leadTimeAvgPrevious: 0,
      leadTimeAvgCurrent: 0,
      leadTimeAvgChange: 0,
      leadTimeAchievementRate: 0,
      leadTimeUnit: "_",

      operationRateIncreaseRate: 12.5,
      operationRateAvgPrevious: 80,
      operationRateAvgCurrent: 90.02,
      operationRateAvgChange: 10,
      operationRateAchievementRate: 100,
      operationRateUnit: "%",

      deliveryRateIncreaseRate: 12.5,
      deliveryRateAvgPrevious: 80,
      deliveryRateAvgCurrent: 90,
      deliveryRateAvgChange: 10,
      deliveryRateAchievementRate: 100,
      deliveryRateUnit: "%",
    },
    graphData: [
      {
        date: "11/19",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/20",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/21",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/24",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/25",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/26",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/27",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/28",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.8,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/01",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 92,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/02",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.3,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/03",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.1,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/04",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.3,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/05",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/08",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/09",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.2,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/10",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.3,
        deliveryComplianceRate: 90,
      },
    ],
    weeklySummary: {
      productionAvg: 0,
      leadTimeAvg: 0,
      // (120 + 90 + 165 + 105 + 160 + 100 + 160) / 7
      operationRateAvg: 128.5,
      deliveryRateAvg: 90,
    },
  },
  {
    // 우진피피피
    companyId: 6,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 24.52,
      productionAvgPrevious: 500,
      productionAvgCurrent: 622.5,
      productionAvgChange: 122.5,
      productionAchievementRate: 103.7,
      productionUnit: "장/시간",

      leadTimeReductionRate: 37.1,
      leadTimeAvgPrevious: 3.5,
      leadTimeAvgCurrent: 2.2,
      leadTimeAvgChange: 1.3,
      leadTimeAchievementRate: 101,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/6",
        dailyProduction: 618.5,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/7",
        dailyProduction: 614,
        dailyLeadTime: 2.2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/10",
        dailyProduction: 619.875,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/11",
        dailyProduction: 613.33,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/12",
        dailyProduction: 615.125,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/13",
        dailyProduction: 612.25,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 613.5625,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 615.5,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 609.25,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 609.25,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 617.8125,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 609.6375,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 615.375,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 611,
        dailyLeadTime: 2.3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 524.6,
      leadTimeAvg: 2.3,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 이룸
    companyId: 9,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 61.9,
      productionAvgPrevious: 50,
      productionAvgCurrent: 80.9,
      productionAvgChange: 30.9,
      productionAchievementRate: 107.9,
      productionUnit: "장/분",

      leadTimeReductionRate: 14.4,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 2.5,
      leadTimeAvgChange: 0.5,
      leadTimeAchievementRate: 105.1,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/10",
        dailyProduction: 81.6,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/11",
        dailyProduction: 82.2,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/12",
        dailyProduction: 81.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/13",
        dailyProduction: 81.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 81.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 82.4,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 81.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 82,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 81.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 81.9,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 82.5,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 82.1,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 82,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 75,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 81.9,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 80.8,
      leadTimeAvg: 2.3,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 인맥스디자인
    companyId: 13,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 43.32,
      productionAvgPrevious: 500,
      productionAvgCurrent: 716.6,
      productionAvgChange: 216.6,
      productionAchievementRate: 102.3,
      productionUnit: "매/시간",

      leadTimeReductionRate: 42,
      leadTimeAvgPrevious: 5,
      leadTimeAvgCurrent: 2.8,
      leadTimeAvgChange: 2.2,
      leadTimeAchievementRate: 103.5,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/10",
        dailyProduction: 720.3,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/11",
        dailyProduction: 721,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/12",
        dailyProduction: 721,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/13",
        dailyProduction: 718.2,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 718.4,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 715.875,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 712.3,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 713.6,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 719.5,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 723.8,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 706.7,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 720.8,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 721.5,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 715,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 713.6,
        dailyLeadTime: 3,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 717.3,
      leadTimeAvg: 3,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 다큐피아
    companyId: 4,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 77.1,
      productionAvgPrevious: 70,
      productionAvgCurrent: 123.9,
      productionAvgChange: 53.9,
      productionAchievementRate: 103.3,
      productionUnit: "장/시간",

      leadTimeReductionRate: 13,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 2.6,
      leadTimeAvgChange: 0.4,
      leadTimeAchievementRate: 103.5,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/11",
        dailyProduction: 127.1,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/12",
        dailyProduction: 127,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/13",
        dailyProduction: 126.4,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 126.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 127,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 127.3,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 126.5,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 127,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 127.2,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 126.8,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 126.8,
      leadTimeAvg: 2.7,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 다큐피아
    companyId: 4,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 106.6,
      productionAvgPrevious: 10,
      productionAvgCurrent: 20,
      productionAvgChange: 10,
      productionAchievementRate: 103.3,
      productionUnit: "권/시간",

      leadTimeReductionRate: 36.6,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 2,
      leadTimeAvgChange: 1,
      leadTimeAchievementRate: 105.2,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/13",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 20,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 포토스24
    companyId: 7,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 100.6,
      productionAvgPrevious: 10,
      productionAvgCurrent: 20,
      productionAvgChange: 10,
      productionAchievementRate: 100.3,
      productionUnit: "권/시간",

      leadTimeReductionRate: 36.4,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 1.9,
      leadTimeAvgChange: 1.1,
      leadTimeAchievementRate: 104.9,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/14",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/04",
        dailyProduction: 20,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      productionAvg: 20,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 부광사
    companyId: 15,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 36.2,
      productionAvgPrevious: 150,
      productionAvgCurrent: 200,
      productionAvgChange: 50,
      productionAchievementRate: 102.1,
      productionUnit: "장/시간",

      leadTimeReductionRate: 40.8,
      leadTimeAvgPrevious: 5,
      leadTimeAvgCurrent: 3,
      leadTimeAvgChange: 2,
      leadTimeAchievementRate: 101.3,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/11",
        dailyProduction: 203.5,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/12",
        dailyProduction: 205.2,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/13",
        dailyProduction: 205.1,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/14",
        dailyProduction: 204.2,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 205.3,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 204.5,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 204.1,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 203.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 205,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 204.5,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 203.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 205.3,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 203.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 204.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 205.2,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 204,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 202.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      /* (202.8 + 204 + 205.25 + 204.875 + 203.875 + 205.375 + 203.875) / 7 */
      productionAvg: 204.2,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 북청사
    companyId: 8,
    dashBoardGraph: "OPERATION_RATE",
    availableMetrics: ["OPERATION_RATE", "DELIVERY_RATE"],
    metrics: {
      productionIncreaseRate: 0,
      productionAvgPrevious: 0,
      productionAvgCurrent: 0,
      productionAvgChange: 0,
      productionAchievementRate: 0,
      productionUnit: "_",

      leadTimeReductionRate: 0,
      leadTimeAvgPrevious: 0,
      leadTimeAvgCurrent: 0,
      leadTimeAvgChange: 0,
      leadTimeAchievementRate: 0,
      leadTimeUnit: "_",

      operationRateIncreaseRate: 12.5,
      operationRateAvgPrevious: 80,
      operationRateAvgCurrent: 90,
      operationRateAvgChange: 10,
      operationRateAchievementRate: 100,
      operationRateUnit: "%",

      deliveryRateAvgChange: 12.5,
      deliveryRateAvgPrevious: 80,
      deliveryRateAvgCurrent: 90,
      deliveryRateIncreaseRate: 10,
      deliveryRateAchievementRate: 100,
      deliveryRateUnit: "%",
    },
    graphData: [
      {
        date: "11/13",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/14",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/17",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/18",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/19",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/20",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/21",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/24",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/25",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/26",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/27",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.1,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/28",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.7,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/01",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.2,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/02",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.8,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/03",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.9,
        deliveryComplianceRate: 90,
      },
    ],
    weeklySummary: {
      productionAvg: 0,
      leadTimeAvg: 0,
      // (91.9 + 91.8 + 90.2 + 90.7 + 90.1 + 90 + 90) / 7
      operationRateAvg: 90.6,
      deliveryRateAvg: 90,
    },
  },
  {
    // 청암
    companyId: 5,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 35.9,
      productionAvgPrevious: 60,
      productionAvgCurrent: 81.5,
      productionAvgChange: 21.5,
      productionAchievementRate: 108.7,
      productionUnit: "장/분",

      leadTimeReductionRate: 21.6,
      leadTimeAvgPrevious: 2.5,
      leadTimeAvgCurrent: 1.9,
      leadTimeAvgChange: 0.6,
      leadTimeAchievementRate: 102.0,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/14",
        dailyProduction: 82.1,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/17",
        dailyProduction: 81.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/18",
        dailyProduction: 81.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/19",
        dailyProduction: 81.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 81.5,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 81.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 81.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 82.1,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 81.7,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 81.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 81.9,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 82,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 81.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 81.7,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/04",
        dailyProduction: 81.7,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      // (81.7 + 81.7 + 81.6 + 82 + 81.9 + 81.8 + 81.7) / 7
      productionAvg: 81.7,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 세원
    companyId: 14,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 35.7,
      productionAvgPrevious: 150,
      productionAvgCurrent: 203.5,
      productionAvgChange: 53.5,
      productionAchievementRate: 101.7,
      productionUnit: "장/시간",

      leadTimeReductionRate: 34.4,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 1.9,
      leadTimeAvgChange: 1.1,
      leadTimeAchievementRate: 101.6,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/19",
        dailyProduction: 203.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/20",
        dailyProduction: 204.4,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/21",
        dailyProduction: 204.2,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/24",
        dailyProduction: 203.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 203.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 204.2,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 206.7,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 206.1,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 204,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 205.7,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 203.8,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/04",
        dailyProduction: 204.6,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/05",
        dailyProduction: 204.7,
        dailyLeadTime: 1.9,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/06",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/07",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      // (204.7 + 204.6 + 203.8 + 205.7 + 204 + 206.1 + 206.7) / 7
      productionAvg: 205,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 유정테크
    companyId: 11,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 150.0,
      productionAvgPrevious: 10,
      productionAvgCurrent: 25.0,
      productionAvgChange: 15.0,
      productionAchievementRate: 100.0,
      productionUnit: "권/시간",

      leadTimeReductionRate: 35.7,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 1.9,
      leadTimeAvgChange: 1.1,
      leadTimeAchievementRate: 103.7,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/24",
        dailyProduction: 23,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/25",
        dailyProduction: 30,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/26",
        dailyProduction: 30,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/27",
        dailyProduction: 30,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 22,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 22,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 22,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 25,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/04",
        dailyProduction: 26,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/05",
        dailyProduction: 30,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/08",
        dailyProduction: 25,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/09",
        dailyProduction: 21,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/10",
        dailyProduction: 22,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/11",
        dailyProduction: 22,
        dailyLeadTime: 2,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      // (20 * 6 + 22) / 7
      productionAvg: 20.2,
      leadTimeAvg: 2,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
  {
    // 신광
    companyId: 3,
    dashBoardGraph: "OPERATION_RATE",
    availableMetrics: ["OPERATION_RATE", "DELIVERY_RATE"],
    metrics: {
      productionIncreaseRate: 0,
      productionAvgPrevious: 0,
      productionAvgCurrent: 0,
      productionAvgChange: 0,
      productionAchievementRate: 0,
      productionUnit: "_",

      leadTimeReductionRate: 0,
      leadTimeAvgPrevious: 0,
      leadTimeAvgCurrent: 0,
      leadTimeAvgChange: 0,
      leadTimeAchievementRate: 0,
      leadTimeUnit: "_",

      operationRateIncreaseRate: 12.5,
      operationRateAvgPrevious: 80,
      operationRateAvgCurrent: 116.77,
      operationRateAvgChange: 10,
      operationRateAchievementRate: 100,
      operationRateUnit: "%",

      deliveryRateIncreaseRate: 12.5,
      deliveryRateAvgPrevious: 80,
      deliveryRateAvgCurrent: 90,
      deliveryRateAvgChange: 10,
      deliveryRateAchievementRate: 100,
      deliveryRateUnit: "%",
    },
    graphData: [
      {
        date: "11/19",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/20",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/21",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/24",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/25",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/26",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/27",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90,
        deliveryComplianceRate: 90,
      },
      {
        date: "11/28",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.7,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/01",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 92.7,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/02",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.7,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/03",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 91.9,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/04",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.4,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/05",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.6,
        deliveryComplianceRate: 90,
      },
      {
        date: "12/08",
        dailyProduction: 0,
        dailyLeadTime: 0,
        operationRate: 90.4,
        deliveryComplianceRate: 90,
      },
    ],
    weeklySummary: {
      productionAvg: 0,
      leadTimeAvg: 0,
      // (90.4 + 90.6 + 90.4 + 91.9 + 90.7 + 92.7 + 91.7) / 7
      operationRateAvg: 91.2,
      deliveryRateAvg: 90,
    },
  },
  {
    // 누리
    companyId: 18,
    dashBoardGraph: "PRODUCTION",
    availableMetrics: ["PRODUCTION", "LEAD_TIME"],
    metrics: {
      productionIncreaseRate: 249.6,
      productionAvgPrevious: 0.2,
      productionAvgCurrent: 0.7,
      productionAvgChange: 0.5,
      productionAchievementRate: 139.9,
      productionUnit: "권/분",

      leadTimeReductionRate: 12.2,
      leadTimeAvgPrevious: 3,
      leadTimeAvgCurrent: 2.6,
      leadTimeAvgChange: 0.4,
      leadTimeAchievementRate: 102.6,
      leadTimeUnit: "일",

      operationRateIncreaseRate: 0,
      operationRateAvgPrevious: 0,
      operationRateAvgCurrent: 0,
      operationRateAvgChange: 0,
      operationRateAchievementRate: 0,
      operationRateUnit: "_",

      deliveryRateAvgChange: 0,
      deliveryRateAvgPrevious: 0,
      deliveryRateAvgCurrent: 0,
      deliveryRateIncreaseRate: 0,
      deliveryRateAchievementRate: 0,
      deliveryRateUnit: "_",
    },
    graphData: [
      {
        date: "11/27",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "11/28",
        dailyProduction: 0.7,
        dailyLeadTime: 2.5,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/01",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/02",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/03",
        dailyProduction: 0.6,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/04",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/05",
        dailyProduction: 0.7,
        dailyLeadTime: 2.5,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/08",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/09",
        dailyProduction: 0.6,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/10",
        dailyProduction: 0.6,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/11",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/12",
        dailyProduction: 0.7,
        dailyLeadTime: 2.5,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/15",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/16",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
      {
        date: "12/17",
        dailyProduction: 0.7,
        dailyLeadTime: 2.7,
        operationRate: 0,
        deliveryComplianceRate: 0,
      },
    ],
    weeklySummary: {
      // (0.7 + 0.7 + 0.7 + 0.7 + 0.7 + 0.6 + 0.6) / 7
      productionAvg: 0.67,
      // (2.7 + 2.7 + 2.7 + 2.5 + 2.7 + 2.7 + 2.7) / 7
      leadTimeAvg: 2.7,
      operationRateAvg: 0,
      deliveryRateAvg: 0,
    },
  },
];
